import { Snowflake } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * TokenPill — small chip showing save-token balance (available/max) with
 * an optional Pro suffix. Sits inside the Streak hero card.
 */
export default function TokenPill({ available, max, pro }) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex", alignItems: "center", gap: 8,
        padding: "6px 12px", borderRadius: 999,
        background: available > 0 ? "rgba(224,158,80,0.22)" : "rgba(0,0,0,0.2)",
        border: `1px solid ${available > 0 ? "rgba(224,158,80,0.5)" : "rgba(255,255,255,0.12)"}`,
      }}
      data-testid="streak-tokens-pill"
    >
      <Snowflake size={13} color={available > 0 ? "#E09E50" : "rgba(255,255,255,0.5)"}/>
      <div style={{ fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 600 }}>
        {t("streak_kids.save_tokens", { count: max, available, max })} {pro && <span style={{ opacity: 0.7 }}>{t("streak_kids.pro_suffix")}</span>}
      </div>
    </div>
  );
}
